import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import {useMediaQuery} from "@material-ui/core";
import DefaultType from "./Fields/DefaultType/DefaultType";
import SelectType from "./Fields/SelectType/Select";
import TypeEntity from "./Fields/EntityExternal/Entity";
import Frequency from "./Fields/Frequency";
import JsonType from "./Fields/JsonType";
import DurationType from "./Fields/DurationType";
import TextType from "./Fields/TextType";
import ScriptType from "./Fields/ScriptType/ScriptType";
import "../FormInline.css"
import EntityMixed from "./Fields/EntityMixed/EntityMixed";
import LocationType from "./Fields/LocationType";
import {useSelector} from "react-redux";
import ColorPickerType from "./Fields/ColorPickerType";
import IconSelectType from "./Fields/IconSelectType/IconSelectType";
import {useEventListener} from "../../../Hooks/useEventListener";
import {useDeepCompareCallback} from "use-deep-compare";

export const FormDynamic = (props) => {
    const {
        field,
        events,
        showLabel,
        errors,
        setValue,
        insertValue,
        values,
        fieldStyles,
        labelStyles,
        goBack,
        focusNow,
        onBlurFromCell,
        history,
        containerArrayPath,
        setValueOnChange,
        doActions,
        globalValues,
        allFieldsDisabled,
        actionsContext,
        screenName,
        renderOptions,
    } = props;
    const isMobile = useMediaQuery('(max-width:700px)');
    const userLanguage = useSelector(state => state.app.userLanguage);
    const fieldContainerRef = useRef(null)
    const onKeyDown = useDeepCompareCallback((e) => {
        if (e.altKey && e.key === 'ArrowLeft') {
            goBack();
            e.preventDefault();

        }
    }, [])

    useEventListener('keydown', onKeyDown, fieldContainerRef.current)

    if (field.hidden) return <></>;
    if (Boolean(screenName ? allFieldsDisabled[screenName] : false)) {
        field.disabled = true;
    }


    function renderFieldsByType(type) {
        switch (type) {
            case 'string':
                return <DefaultType
                    field={field}
                    events={events}
                    values={values}
                    doActions={doActions}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    errors={errors}
                    goBack={goBack}
                    focusNow={focusNow}
                    onBlurFromCell={onBlurFromCell}
                    history={history}
                    containerArrayPath={containerArrayPath}
                    isMobile={isMobile}
                    setValueOnChange={setValueOnChange}
                    globalValues={globalValues}
                    actionsContext={actionsContext}
                    screenName={screenName}
                    userLanguage={userLanguage}
                />;
            case 'select':
                return <SelectType field={field}
                                   values={values}
                                   showLabel={showLabel}
                                   fieldStyles={fieldStyles}
                                   labelStyles={labelStyles}
                                   setValue={setValue}
                                   errors={errors}
                                   goBack={goBack}
                                   focusNow={focusNow}
                                   onBlurFromCell={onBlurFromCell}
                                   containerArrayPath={containerArrayPath}
                                   isMobile={isMobile}
                                   setValueOnChange={setValueOnChange}
                                   globalValues={globalValues}
                                   screenName={screenName}
                                   renderOptions={renderOptions}
                />;
            case 'objSelect':
                return <SelectType field={field}
                                   values={values}
                                   showLabel={showLabel}
                                   fieldStyles={fieldStyles}
                                   labelStyles={labelStyles}
                                   setValue={setValue}
                                   errors={errors}
                                   goBack={goBack}
                                   focusNow={focusNow}
                                   onBlurFromCell={onBlurFromCell}
                                   containerArrayPath={containerArrayPath}
                                   isMobile={isMobile}
                                   setValueOnChange={setValueOnChange}
                                   globalValues={globalValues}
                                   screenName={screenName}
                />;
            case 'text':
                return <TextType
                    field={field}
                    values={values}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    errors={errors}
                    goBack={goBack}
                    focusNow={focusNow}
                    onBlurFromCell={onBlurFromCell}
                    history={history}
                    containerArrayPath={containerArrayPath}
                    isMobile={isMobile}
                    setValueOnChange={setValueOnChange}
                    globalValues={globalValues}
                    screenName={screenName}
                />;
            case 'number':
                return <DefaultType
                    field={field}
                    values={values}
                    events={events}
                    doActions={doActions}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    errors={errors}
                    goBack={goBack}
                    focusNow={focusNow}
                    onBlurFromCell={onBlurFromCell}
                    history={history}
                    containerArrayPath={containerArrayPath}
                    isMobile={isMobile}
                    setValueOnChange={setValueOnChange}
                    globalValues={globalValues}
                    actionsContext={actionsContext}
                    screenName={screenName}
                />;
            case 'integer':
                return <DefaultType
                    field={field}
                    values={values}
                    events={events}
                    doActions={doActions}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    errors={errors}
                    goBack={goBack}
                    focusNow={focusNow}
                    onBlurFromCell={onBlurFromCell}
                    history={history}
                    containerArrayPath={containerArrayPath}
                    isMobile={isMobile}
                    setValueOnChange={setValueOnChange}
                    globalValues={globalValues}
                    actionsContext={actionsContext}
                    screenName={screenName}
                />;
            case 'date':
            case 'month':
                return <DefaultType
                    field={field}
                    values={values}
                    events={events}
                    doActions={doActions}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    errors={errors}
                    goBack={goBack}
                    focusNow={focusNow}
                    onBlurFromCell={onBlurFromCell}
                    history={history}
                    containerArrayPath={containerArrayPath}
                    isMobile={isMobile}
                    setValueOnChange={setValueOnChange}
                    globalValues={globalValues}
                    actionsContext={actionsContext}
                    screenName={screenName}
                />;
            case 'time':
                return <DefaultType
                    field={field}
                    values={values}
                    events={events}
                    doActions={doActions}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    errors={errors}
                    goBack={goBack}
                    focusNow={focusNow}
                    onBlurFromCell={onBlurFromCell}
                    history={history}
                    containerArrayPath={containerArrayPath}
                    isMobile={isMobile}
                    setValueOnChange={setValueOnChange}
                    globalValues={globalValues}
                    actionsContext={actionsContext}
                    screenName={screenName}
                />;
            case 'datetime':
                return <DefaultType
                    field={{...field, type: 'datetime-local'}}
                    events={events}
                    doActions={doActions}
                    values={values}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    errors={errors}
                    goBack={goBack}
                    focusNow={focusNow}
                    onBlurFromCell={onBlurFromCell}
                    history={history}
                    containerArrayPath={containerArrayPath}
                    isMobile={isMobile}
                    setValueOnChange={setValueOnChange}
                    globalValues={globalValues}
                    actionsContext={actionsContext}
                    screenName={screenName}
                />;
            case 'bool':
                return <SelectType
                    field={field}
                    values={values}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    errors={errors}
                    goBack={goBack}
                    focusNow={focusNow}
                    onBlurFromCell={onBlurFromCell}
                    containerArrayPath={containerArrayPath}
                    isMobile={isMobile}
                    setValueOnChange={setValueOnChange}
                    globalValues={globalValues}
                    screenName={screenName}
                    events={events}
                    doActions={doActions}
                />;
            case 'entityExternal':
                return <TypeEntity
                    field={field}
                    values={values}
                    events={events}
                    doActions={doActions}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    errors={errors}
                    goBack={goBack}
                    focusNow={focusNow}
                    onBlurFromCell={onBlurFromCell}
                    history={history}
                    containerArrayPath={containerArrayPath}
                    isMobile={isMobile}
                    setValueOnChange={setValueOnChange}
                    globalValues={globalValues}
                    screenName={screenName}
                    actionsContext={actionsContext}
                />;
            case 'entityMixed':
                return <EntityMixed
                    field={field}
                    values={values}
                    events={events}
                    doActions={doActions}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    insertValue={insertValue}
                    errors={errors}
                    goBack={goBack}
                    history={history}
                    containerArrayPath={containerArrayPath}
                    isMobile={isMobile}
                    globalValues={globalValues}
                    screenName={screenName}
                />;
            case 'frequency':
                return <Frequency
                    field={field}
                    values={values}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    errors={errors}
                    goBack={goBack}
                    focusNow={focusNow}
                    onBlurFromCell={onBlurFromCell}
                    containerArrayPath={containerArrayPath}
                    isMobile={isMobile}
                    globalValues={globalValues}
                    screenName={screenName}
                />;
            case 'jsonObject':
                return <ScriptType
                    field={field}
                    values={values}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    errors={errors}
                    goBack={goBack}
                    focusNow={focusNow}
                    onBlurFromCell={onBlurFromCell}
                    containerArrayPath={containerArrayPath}
                    isMobile={isMobile}
                    globalValues={globalValues}
                    screenName={screenName}
                />;
            case 'script':
                return <ScriptType
                    field={field}
                    values={values}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    errors={errors}
                    goBack={goBack}
                    focusNow={focusNow}
                    onBlurFromCell={onBlurFromCell}
                    containerArrayPath={containerArrayPath}
                    isMobile={isMobile}
                    globalValues={{...globalValues, ...actionsContext}}
                    events={events}
                    doActions={doActions}
                />;
            case 'auditId':
                return <JsonType
                    field={field}
                    values={values}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    errors={errors}
                    goBack={goBack}
                    focusNow={focusNow}
                    onBlurFromCell={onBlurFromCell}
                    containerArrayPath={containerArrayPath}
                    isMobile={isMobile}
                    events={events}
                    doActions={doActions}
                />;
            case 'duration':
                return <DurationType
                    field={field}
                    values={values}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    errors={errors}
                    goBack={goBack}
                    focusNow={focusNow}
                    onBlurFromCell={onBlurFromCell}
                    history={history}
                    containerArrayPath={containerArrayPath}
                    isMobile={isMobile}
                    globalValues={globalValues}
                    screenName={screenName}
                    events={events}
                    doActions={doActions}
                />;
            case 'location':
                return <LocationType
                    field={field}
                    values={values}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    errors={errors}
                    goBack={goBack}
                    focusNow={focusNow}
                    onBlurFromCell={onBlurFromCell}
                    history={history}
                    containerArrayPath={containerArrayPath}
                    isMobile={isMobile}
                    globalValues={globalValues}
                    events={events}
                    doActions={doActions}
                />;
            case 'password':
                return <DefaultType
                    field={field}
                    events={events}
                    values={values}
                    doActions={doActions}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    errors={errors}
                    goBack={goBack}
                    focusNow={focusNow}
                    onBlurFromCell={onBlurFromCell}
                    history={history}
                    containerArrayPath={containerArrayPath}
                    isMobile={isMobile}
                    setValueOnChange={setValueOnChange}
                    globalValues={globalValues}
                    actionsContext={actionsContext}
                    screenName={screenName}
                />;
            case 'colorPicker':
                return <ColorPickerType
                    field={field}
                    values={values}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    containerArrayPath={containerArrayPath}
                />
            case 'iconType':
                return <IconSelectType
                    field={field}
                    values={values}
                    showLabel={showLabel}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    setValue={setValue}
                    containerArrayPath={containerArrayPath}
                />
            default:
                return <>undefined type {field.type}</>
        }
    }

    return (
        <div
            ref={fieldContainerRef}
            style={{display: 'contents'}}>
            {renderFieldsByType(field.type)}
        </div>
    )
};


FormDynamic.propTypes = {
    field: PropTypes.shape({
        name: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
        autoFocus: PropTypes.bool,
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        isArray: PropTypes.bool,
        arrayType: PropTypes.string,
        dropdown: PropTypes.string,
        minLength: PropTypes.number,
        maxLength: PropTypes.number,
        min: PropTypes.number,
        max: PropTypes.number,
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        values: PropTypes.array,
        trackChange: PropTypes.bool,
        entity: PropTypes.string,
    }),
    events: PropTypes.array,
    setValue: PropTypes.func.isRequired,
    setValueOnChange: PropTypes.bool, //force set value, when is false value set onBlur
    values: PropTypes.object,
    fieldStyles: PropTypes.object,
    labelStyles: PropTypes.object,
    errors: PropTypes.array,
    goBack: PropTypes.func,
    doActions: PropTypes.func,
    globalValues: PropTypes.object,
    actionsContext: PropTypes.object,
    allFieldsDisabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    //from array fields
    containerArrayPath: PropTypes.string,
};

FormDynamic.defaultProps = {
    actionsContext: {},
    doActions: () => {
    }
};